import * as React from "react";

const ProductLogo = (props) => (
    <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1080 1080"
        width={60}
        height={60}
        className="cos-home-product-logo"
        {...props}
    >
        <path
            d="M837.929 137.963v-1.636L623.034 390.3V255.364c-85.59 0-165.174 46.549-165.174 153.161v130.394h-.195v12.256h.195v34.34l-51.732 61.14v-294.6c-85.59 0-165.174 46.549-165.174 153.161v438.457c85.59 0 165.174-46.549 165.174-153.161v-42.051l51.537-60.91v159.435c85.59 0 165.174-46.549 165.174-153.161v-142.65h.195v-59.067l50.838-60.084v314.364c85.59 0 165.174-46.549 165.174-153.162v-456.9Z"
            style={{
                fill: "#618be0",
            }}
        />
    </svg>
);

export default ProductLogo;
